export const UPDATE_TABLE_DATA = 'updateTableData';
export const UPDATE_MODAL_STATE = 'openModal';
export const SET_TABLE_ROWS = 'setTableRows';
export const SET_TABLE_COLS = 'setTableCols';
export const SET_TABLE_MODE = 'setTableMode';
export const SET_METRICS_SYSTEM = 'setMetricsSystem';
export const SET_METRIC_RADIO_STATE = 'setMetricRadioState';
export const SET_CURRENT_METRIC = 'setCurrentMetric';
